export default __webpack_public_path__ + "static/media/640_store03-en-mobile.3797be89.png";